import { Injectable } from '@angular/core';
import {
    ActiveState,
    EntityState,
    EntityStore,
    StoreConfig,
} from '@datorama/akita';
import { PaymethodWizard } from './paymethod-wizard.model';

export interface PaymethodWizardState
    extends EntityState<PaymethodWizard>,
        ActiveState {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'paymethod-wizard', resettable: true })
export class PaymethodWizardStore extends EntityStore<
    PaymethodWizardState,
    PaymethodWizard
> {
    constructor() {
        super();
    }
}
